var map = {
	"./tutorial-normal-competitiveness-1.jpg": "jomD",
	"./tutorial-tool-competitiveness-1.jpg": "/Zy+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QLzv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/tutorial\-.*\-competitiveness\-1\.jpg$
// module id = QLzv
// module chunks = 3